import { TasksService } from '../../services/tasks.service';
import { AccountsService, EmployeesService, ContactsService, MasterdataAService } from '../../services';
import { AuthUserService } from '../../authsettings/services/authusers.service';

export const taskState: aboTheme.IState = {
    parent: 'app',
    name: "tasks",
    url: "/tasks",
    component: 'taskComponent',
    redirectTo: "tasks.list",
    data: {
        permissions: {
            only: ['BACKOFFICE'],
            redirectTo: 'schedule'
        }
    }
};

export const taskListState: aboTheme.IState = {
    name: "tasks.list",
    url: "/list",
    resolve: {
        tasks: (TasksService: TasksService) => { "ngInject"; return TasksService.all(); },
        taskStatuses : (MasterdataAService: MasterdataAService) => { "ngInject"; return MasterdataAService.getItems('TaskStatus'); }
    },
    views: {
        "main": 'taskListComponent'
    },
};

export const taskItemState = {
    name: "tasks.item",
    url: "/:id",
    params: {
        "isArchive": null
    },
    resolve: {
      task: (TasksService: TasksService, $stateParams: ng.ui.IStateParamsService) => {
        "ngInject";
        if ($stateParams['id']) {
          return TasksService.get($stateParams['id']);
        }
      }
    },
    views: {
        "main": 'taskItemComponent'
    }
};

export const taskItemBasicState: aboTheme.IState = {

    name: "tasks.item.basic",
    url: "/basic",
    modal: ['task'],
    resolve: {
        users: (EmployeesService: EmployeesService) => { 'ngInject'; return EmployeesService.gatBackoffice(); },
        accounts : (AccountsService: AccountsService) => { "ngInject"; return AccountsService.all(); },
        contacts: (ContactsService: ContactsService) => { 'ngInject'; return ContactsService.all(); }, 
        employees : (EmployeesService: EmployeesService) => { "ngInject"; return EmployeesService.getEmployeesByStatus(); },
        taskStatuses : (MasterdataAService: MasterdataAService) => { "ngInject"; return MasterdataAService.getItems('TaskStatus'); }
    },
    component: 'taskItemBasicComponent'
};

export const taskArchiveState: aboTheme.IState = {
    name: "tasks.archive",
    url: "/archive",
    resolve: {
        tasks: (TasksService: TasksService) => { "ngInject"; return TasksService.getArchive(); },
    },
    views: {
        "main": 'taskArchiveComponent'
    },
};


// WEBPACK FOOTER //
// ./src/app/modules/tasks/tasks.states.ts